import { IDatePickerValue } from '../../interface';
import { IDatePickerHeaderProps } from '../../interface/datePicker';
import React from 'react';
import './index.scss';
import { classSet } from '@umu/umu-dom';
import { Iconfont } from '@umu/umu-design';
import { ImgApi } from './images';

interface IProps extends IDatePickerHeaderProps {
  isOpen?: boolean;
  value: IDatePickerValue;
  onClick: () => void
  onClearClick?: () => void
}

const CalendarDaysHeader = (props: IProps) => {
  const { placeholder, suffixIcon, value = [], allowClear = false, bordered = true, disabled = false, format, onClick, onClearClick } = props;
  const renderSuffixIcon = () => {
    return suffixIcon || <img src={ImgApi.dayHeaderCalendarIcon} className='day-header-calendar-icon' />
  }
  return (
    <div onClick={onClick} className={classSet({
      'umu-calendar-day-header-info': true,
      'umu-calendar-day-header-info-border': bordered,
      'umu-calendar-day-header-info-disabled': disabled,
    })}>
      <span className='umu-calendar-day-header-label'>{format && format(value) || placeholder}</span>
      <span>{renderSuffixIcon()}</span>
      {allowClear && <Iconfont type='Delete2' className='calendar-day-icon' onClick={onClearClick} />}
    </div >
  );
}

export {
  CalendarDaysHeader
};
